const QuestionType = {
  TRUE_FALSE: "truefalse",
  IMAGE: "image",
  TEXT_ONLY: "textonly",
  IMAGE_ANSWER: "imageanswer",
};

export default QuestionType;
